const de = {
  title: 'Berechtigungs Einstellungen',
  permissionScheme: 'Berechtigungsschema',
  roles: 'Rollen',
  role: 'Rolle',
  roleName: 'Rollenname',
  entitlements: 'Entitlements',
  entitlement: 'Entitlement',
  permission: 'Berechtigung',
  status: 'Status',
  icon: 'Icon',
  actions: 'Aktionen',
  recipients: 'Empfänger',
  authorRole: 'Autorenrolle',
  deactivateRole: 'Rolle deaktivieren',
  activateRole: 'Rolle aktivieren',
  cancel: 'Abbrechen',
  deactivationModal: {
    title: 'Wirklick deaktivieren?',
    message: 'Wollen Sie wirklich diese Rolle deaktivieren?'
  },
  activationModal: {
    title: 'Wirklick aktivieren?',
    message: 'Wollen Sie wirklich diese Rolle aktivieren?'
  },
  successfullyUpdated: 'Die Rolle wurde erfolgreich geupdated!',
  errorLoading: 'Berechtigungsschema konnte nicht geladen werden.',
  noGroupRoles: 'Dieses Entitlement ist in keiner Rolle enthalten',
  noItemFound: 'Es wurde kein Element gefunden.',
  editRole: 'Rolle bearbeiten',
  deleteRole: 'Rolle löschen',
  createRole: 'Rolle erstellen',
  roleCreation: 'Rollenerstellung',
  roleEditing: 'Rollenbearbeitung',
  editPermission: 'Berechtigung bearbeiten',
  deletePermission: 'Berechtigung löschen',
  createPermission: 'Berechtigung erstellen',
  permissionCreation: 'Berechtigungserstellung',
  permissionEditing: 'Berechtigungsbearbeitung',
  active: 'Aktiv',
  alertsRole: {
    saveFailed: 'Die Rolle konnte nicht gespeichert werden.',
    saveSuccess: 'Die Rolle wurde erfolgreich gespeichert.',
    deleteFailed: 'Die Rolle konnte nicht gelöscht werden. Grund: {{cause}}',
    deleteSuccess: 'Die Rolle wurde erfolgreich gelöscht.'
  },
  deleteModalRole: {
    title: 'Wirklich löschen?',
    message: 'Wollen Sie wirklich diese Rolle löschen?'
  },
  alertsPermission: {
    saveFailed: 'Die Berechtigung konnte nicht gespeichert werden.',
    saveSuccess: 'Die Berechtigung wurde erfolgreich gespeichert.',
    deleteFailed: 'Die Berechtigung konnte nicht gelöscht werden. Grund: {{cause}}',
    deleteSuccess: 'Die Berechtigung wurde erfolgreich gelöscht.'
  },
  deleteModalPermission: {
    title: 'Wirklich löschen?',
    message: 'Wollen Sie wirklich diese Berechtigung löschen?'
  },
  alertsEntitlement: {
    deleteFailed: 'Das Entitlement konnte nicht gelöscht werden.',
    deleteSuccess: 'Das Entitlement wurde erfolgreich gelöscht.'
  },
  deleteModalEntitlment: {
    title: 'Wirklich löschen?',
    message:
      'Wollen Sie wirklich dieses Entitlement löschen? Wenn ein Nutzer das Entitlement besitzt und sich einloggt, wird automatisch dieses erneut angelegt!'
  }
};

export default de;
export type ManagePermissionsSettingsTranslation = typeof de;
